export default {
    name: 'Nazwisko',
    tel: 'Telefon',
    save: 'Zapisz',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    delete: 'Usuń',
    complete: 'Kompletne',
    loading: 'Ładowanie...',
    telEmpty: 'Proszę wypełnić tel',
    nameEmpty: 'Wprowadź nazwisko',
    nameInvalid: 'Błędna nazwa',
    confirmDelete: 'Czy na pewno chcesz usunąć',
    telInvalid: 'Nieprawidłowy numer telefonu',
    vanCalendar: {
      end: 'Koniec',
      start: 'Start',
      title: 'Kalendarz',
      startEnd: 'Start/Koniec',
      weekdays: ['Nie', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'],
      monthTitle: (year, month) => `${year}/${month}`,
      rangePrompt: (maxRange) => `Wybierz nie więcej niż ${maxRange} dni`,
    },
    vanCascader: {
      select: 'Wybierz',
    },
    vanContactCard: {
        addText: 'Dodaj kontakt'
    },
    vanContactList: {
        addText: 'Dodaj kontakt'
    },
    vanPagination: {
      prev: 'Poprzednia',
      next: 'Następna',
    },
    vanPullRefresh: {
      pulling: 'Pociągnij aby odświeżyć...',
      loosing: 'Puść aby odświeżyć...',
    },
    vanSubmitBar: {
      label: 'Suma:',
    },
    vanCoupon: {
      unlimited: 'Unlimited',
      discount: (discount) => `${discount * 10}% zniżki`,
      condition: (condition) => `Przynajmniej ${condition}`,
    },
    vanCouponCell: {
      title: 'Kupon',
      tips: 'Brak kuponów',
      count: (count) => `Aktywnych kuponów: ${count}`,
    },
    vanCouponList: {
      empty: 'Brak kuponów',
      exchange: 'Użyj',
      close: 'Zamknij',
      enable: 'Dostępne',
      disabled: 'Niedostępne',
      placeholder: 'Kod kuponu',
    },
    vanAddressEdit: {
      area: 'Obszar',
      postal: 'pocztowy',
      areaEmpty: 'Wybierz obszar',
      addressEmpty: 'Adres nie może być pusty',
      postalEmpty: 'Błędny kod pocztowy',
      defaultAddress: 'Ustaw jako domyślny adres',
      telPlaceholder: 'Telefon',
      namePlaceholder: 'Nazwisko',
      areaPlaceholder: 'obszar'
    },
    vanAddressEditDetail: {
        label: 'Adres',
        placeholder: 'Adres'
    },
    vanAddressList: {
      add: 'Dodaj nowy adres',
    },
  };